import { ElMessage, ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { onMounted, reactive, ref, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import apis from "@/api";
import SrcAudit from "../components/SrcAudit";
import common from "../composables/common";
import AuditState from "../Detail/components/AuditState";
import DetailAside from "./components/DetailAside";
import { USER_AUTH } from "@/store/mutation-types";
import IopEvent from "../components/IopEvent";
import download from "@/utils/download";
import OfferRefDemandDialog from "@/views/Home/MyNeeds/components/OfferRefDemandDialog";
import SensitiveWords from "../components/SensitiveWords";
export default {
  name: "Index",
  components: {
    SensitiveWords,
    OfferRefDemandDialog,
    IopEvent,
    DetailAside,
    AuditState,
    SrcAudit
  },
  setup(props, ctx) {
    const {
      initUserInfo,
      commonData,
      getRolesOfLogin,
      smsAuditRoleAuth
    } = common();
    const {
      singleDownload
    } = download();
    const asideRef = ref(null);
    const router = useRouter();
    const route = useRoute();
    const data = reactive({
      sensWordsList: [],
      belongDepart: 'jike',
      canAudit: false,
      offerDemandVisible: false,
      oriSmsCtt: '',
      offerIds: [],
      canResubmit: false,
      submitAgain: 0,
      loading: false,
      process: {},
      auditTip: ["驳回", "待审核", "通过", "保留意见"],
      auditClass: ["audit-bohui", "audit-daishenhe", "audit-tongyi", "audit-baoliu"],
      roles: [],
      auditSMss: [],
      auditRole: {},
      auditDialogShow: false,
      smsTypes: [],
      demand: {},
      smsAssetsInfo: {},
      demandId: route.query.demandId,
      fileList: []
    });
    const loadDemand = () => {
      apis.getDemandById({
        id: data.demandId
      }).then(res => {
        if (res.success) {
          data.demand = res.data;
          const validDate = [res.data.validDateBgn, res.data.validDateEnd];
          data.demand.validDate = validDate;
          loadSmsAssets();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const initSmsType = () => {
      apis.queryPositionTree("sms").then(res => {
        if (res.success) {
          data.smsTypes = res.data[0].children;
        }
      });
    };
    const toBack = () => {
      router.go(-1);
    };
    const loadSmsAssets = () => {
      apis.getSmsById({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          const aids = res.data.srcId;
          apis.getSensWordByAssetsIds({
            aids
          }).then(res => {
            if (res.code == 200) {
              data.sensWordsList = res.data;
            }
          });
          data.smsAssetsInfo = res.data;
          data.belongDepart = res.data.belongDepart;
          data.offerIds = res.data.offerIds ? res.data.offerIds.split(",") : [];
          let resubmit = true;
          for (const appr of data.smsAssetsInfo.approveInfos) {
            if (appr.approveState == 0) {
              resubmit = false;
              break;
            }
          }
          data.canResubmit = resubmit && data.demand.state == 6 && data.demand.createrId == commonData.userInfo.userId;
          for (const appr of data.smsAssetsInfo.approveInfos) {
            if (appr.approveState === 0) {
              data.canAudit = true;
              break;
            }
          }
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        asideRef.value.refresh();
      });
    };
    const showAuditDialog = auditRole => {
      data.auditRole = auditRole;
      data.auditSMss = [data.smsAssetsInfo];
      data.auditDialogShow = true;
    };
    const mngerAudit = () => {
      data.loading = true;
      apis.mngerAudit({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          loadDemand();
          // loadSmsAssets();
          data.process = {
            status: 1
          };
          ElMessage.success("成功提交领导复审");
        } else {
          ElMessage.error(res.msg);
        }
        data.loading = false;
      });
    };
    const processOfDemandId = () => {
      apis.getByDemandId({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.process = res.data;
        } else {
          ElMessage.error("获取流程信息失败");
        }
      });
    };
    const showAuditBtn = auth => {
      let userAuth = sessionStorage.getItem(USER_AUTH);
      var btnPermsArr = JSON.parse(userAuth ? userAuth : '[]');
      if (btnPermsArr.includes(auth)) {
        return true;
      } else {
        return false;
      }
    };
    const loadDemandAttachs = () => {
      apis.getAttachments({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.fileList = res.data;
          data.fileList.forEach(f => {
            f.name = f.fileName;
            f.url = f.fileUrl;
          });
        }
      });
    };
    const handleSubmitAgain = submitAgain => {
      if (submitAgain) {
        let msg = '确认重提吗？';
        if (data.smsAssetsInfo.content == data.oriSmsCtt) {
          msg = '短信内容未发生改变，' + msg;
        }
        ElMessageBox.confirm(msg, {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          data.demand.positionId = data.smsAssetsInfo.positionId;
          data.demand.smsContent = data.smsAssetsInfo.content;
          data.demand.remark = data.smsAssetsInfo.content;
          data.demand.belongDepart = data.belongDepart;
          apis.smsSubmitAgain(data.demand).then(res => {
            if (res.success) {
              loadDemand();
              // loadSmsAssets();
              data.submitAgain = !submitAgain;
              ElMessage.success("短信需求重提成功");
            } else {
              ElMessage.error("短信需求重提异常");
            }
          });
        });
      } else {
        data.oriSmsCtt = data.smsAssetsInfo.content;
        data.submitAgain = !submitAgain;
      }
    };
    const downloadAttach = file => {
      singleDownload(file.fileId, file.fileName).then(() => {});
    };
    onMounted(() => {
      initUserInfo();
      getRolesOfLogin();
      initSmsType();
      processOfDemandId();
      if (data.demandId) {
        loadDemand();
        // loadSmsAssets();
        loadDemandAttachs();
      }
    });
    return {
      ...toRefs(commonData),
      ...toRefs(data),
      asideRef,
      smsAuditRoleAuth,
      loadSmsAssets,
      showAuditDialog,
      mngerAudit,
      showAuditBtn,
      handleSubmitAgain,
      toBack,
      downloadAttach
    };
  }
};